// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 종목 시세 알림 모달 — AlertQuickPopup(aqp-*) 스타일에 추가되는 부분만 정의 */

.sam-price-input {
  flex: 1 1;
  padding: 5px 7px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
}
.sam-price-input:focus { outline: none; border-color: #4a90e2; }

.sam-price-suffix {
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
}

.sam-current-price {
  font-size: 12px;
  color: #444;
  padding-top: 8px;
  border-top: 1px solid #eee;
}
.sam-current-price strong { color: #1a1a2e; }

.sam-current-price-note {
  margin-left: 6px;
  font-size: 11px;
  color: #999;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/StockAlertModal.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA,yBAAyB,aAAa,EAAE,qBAAqB,EAAE;;AAE/D;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,4BAA4B,cAAc,EAAE;;AAE5C;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb","sourcesContent":["/* 종목 시세 알림 모달 — AlertQuickPopup(aqp-*) 스타일에 추가되는 부분만 정의 */\n\n.sam-price-input {\n  flex: 1;\n  padding: 5px 7px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n}\n.sam-price-input:focus { outline: none; border-color: #4a90e2; }\n\n.sam-price-suffix {\n  font-size: 12px;\n  color: #666;\n  flex-shrink: 0;\n}\n\n.sam-current-price {\n  font-size: 12px;\n  color: #444;\n  padding-top: 8px;\n  border-top: 1px solid #eee;\n}\n.sam-current-price strong { color: #1a1a2e; }\n\n.sam-current-price-note {\n  margin-left: 6px;\n  font-size: 11px;\n  color: #999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
